import React from "react";
import { Form, Col } from "react-bootstrap";

import { connect } from "react-redux";
import { changeOpacity } from "../actions";

const OpacityRender = ({opacity = 0.5, change = () => {}}) => {
    return (
        <Col className="opacity-box">
            <Form.Label className="mr-5 opacity-layer">Opacité</Form.Label>
            <Form.Range value={opacity * 100} onChange={change} />
        </Col>
    )
}

const mapStateToProps = (state) => {
	return {
		responsiveModal: state.mainAppReducer.responsiveModal,
		refIndic: state.refIndic,
		setRef: state.setRef.ref,
		territoire: state.setTerritoire,
		navigationType: state.navigationType,
		navigationView: state.navigationView,
		legendUrl: state.legendUrl,
		opacity: state.setTerritoire.opacity,
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		change: (opacity) => dispatch(changeOpacity(opacity)),
	};
};

const OpacityRange = connect(mapStateToProps, mapDispatchToProps)(OpacityRender);

export default OpacityRange;
